// src/utils/fileLoader.js
const fileCache = new Map();

// Update your fetchFile function with better error handling:
async function fetchFile(filePath, options = {}) {
    try {
      // Normalize path for consistent URL format
      const normalizedPath = filePath.startsWith('/') ? filePath.substring(1) : filePath;
      const url = `/${normalizedPath}`;
      
      console.log(`Fetching file: ${url}`);
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Cache-Control': 'no-cache' }
      });
      
      if (!response.ok) {
        console.error(`Failed to fetch file: ${url} (${response.status} ${response.statusText})`);
        throw new Error(`Failed to fetch file: ${url} (${response.status} ${response.statusText})`);
      }
      
      const content = options.encoding === 'utf8' || options.encoding === 'utf-8' 
        ? await response.text()
        : await response.arrayBuffer();
        
      // Check if content is valid
      if (options.encoding === 'utf8' && (!content || content.length < 10)) {
        console.error(`Empty or too small file content for: ${url}`);
        throw new Error(`Empty or too small file content for: ${url}`);
      }
      
      return content;
        
    } catch (error) {
      console.error(`Error fetching file ${filePath}:`, error);
      
      // Provide a more descriptive error for debugging
      if (error.message.includes('Failed to fetch')) {
        console.error(`This may indicate the file doesn't exist at this path or there's a CORS issue`);
      }
      
      throw error;
    }
  }